import React, { useState } from "react";

// PasswordInput: controlled or uncontrolled show/hide, accessible, clean
export default function PasswordInput({
  id,
  value,
  onChange,
  placeholder = "Enter password",
  show,
  setShow,
  label,                // Optional label for accessibility
  disabled = false,
  error = "",
  inputRef,
  autoComplete = "off", // Default off unless specified
  ...rest
}) {
  // If parent didn't pass show/setShow, manage it locally
  const [localShow, setLocalShow] = useState(false);
  const isControlled = typeof show === "boolean" && typeof setShow === "function";
  const reveal = isControlled ? show : localShow;
  const toggle = isControlled ? setShow : setLocalShow;

  return (
    <div style={{ position: "relative", marginBottom: 0 }}>
      {label && (
        <label htmlFor={id} style={{ fontWeight: 500, marginBottom: 5, display: "block" }}>
          {label}
        </label>
      )}
      <input
        type={reveal ? "text" : "password"}
        id={id}
        ref={inputRef}
        value={value}
        onChange={e => (onChange ? onChange(e) : null)}
        placeholder={placeholder}
        disabled={disabled}
        aria-invalid={!!error}
        className="auth-input" // Consistent with your main auth input
        autoComplete={autoComplete}
        style={{
          width: "100%",
          paddingRight: "45px", // Room for eye button
          ...(error ? { border: "1.5px solid #e24" } : {})
        }}
        {...rest}
      />
      <button
        type="button"
        onClick={() => toggle(v => !v)}
        tabIndex={-1}
        aria-label={reveal ? "Hide password" : "Show password"}
        style={{
          position: "absolute",
          right: 5,
          top: "50%",
          transform: "translateY(-50%)",
          background: "none",
          border: "none",
          cursor: "pointer",
          padding: 0,
          height: "2.1rem",
          width: "38px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        {reveal ? (
          // Hide SVG
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth="2">
            <path d="M17.94 17.94A10.05 10.05 0 0 1 12 20c-5.05 0-9.27-3.07-11-7.5a12.43 12.43 0 0 1 3.22-4.63M1 1l22 22" />
            <path d="M9.53 9.53A3.5 3.5 0 0 0 12 15.5c1.6 0 2.94-1.01 3.41-2.43M12 4c3.31 0 6.22 1.65 8 4.5-1.07 1.53-2.63 3.18-4.36 4.63" />
          </svg>
        ) : (
          // Show SVG
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth="2">
            <circle cx="12" cy="12" r="3.5" />
            <path d="M2 12C3.73 7.57 7.95 4.5 12 4.5s8.27 3.07 10 7.5c-1.73 4.43-5.95 7.5-10 7.5S3.73 16.43 2 12z" />
          </svg>
        )}
      </button>
      {error && <div className="field-error">{error}</div>}
    </div>
  );
}
